export default {
  title_left: `Plastická chirurgie a laserové <br/> léčebné centrum`,
  title_right: `Konzultační místo`,
};


// WEBPACK FOOTER //
// ./src/texts/czech/footer.js